import React, { useEffect, useRef, useState } from "react";
import { PostDto, printDto } from "../../../api/interfaces/Posts";
import { useLoader } from "../../../Loader/LoaderContext";
import { useNavigate } from "react-router-dom";
import Pagination from "../../Portals/usersMangmnt/Pagination";
import {
  deleteService,
  getService,
  postService,
} from "../../../servce/ApisService";
import { API_ENDPOINTS } from "../../../api";
import { useToaster } from "../../../Toaster/Toaster";

type FilterType = {
  role: string[];
  status: string[];
  leads: string[];
  addedByLeads: number[];
  assignedTo: number[];
  statusInPosts: string[];
  serviceFilterInPosts: string[];
  featuredTypeFilter: string[];
  postType: string[];
  pitchedBy: number[];
  country: number[];
  types: string[];
  companyType: string[];
  allPost: string[];
  allEvents: string[];
  allExpiredEvents: string[];
};
interface LeadsTableProps {
  leads: PostDto[]; // Use DTO for leads prop
}
const PrintAd: React.FC = () => {
  type SortType = {
    column: string;
    direction: number;
  };
  interface VehicleContent {
    status: string;
    // add other fields that exist in the objects inside content, e.g., id, title, etc.
  }
  const [isFeatured, setFeatured] = useState(false);
  const [isAssigned, setIsAssigned] = useState(false);
  const [isAssignable, setIsAssignable] = useState(false);
  const [isStatus, setIsStatus] = useState(false);
  const user = {
    status: "On Hold",
    // Add other user properties if needed
  };
  const [postCount, setPostCount] = useState<any | null>();
  const [name, setName] = useState("");
  const [assignedName, setAssigedName] = useState("");
  const [addedBy, setAddedBy] = useState<any[]>([]);
  const [addedByLeads, setAddedbByLeads] = useState<any[]>([]);
  const [searchInputAddedBy, setSearchInputAddedBy] = useState("");
  const [page, setPage] = useState(0);
  const [statusValue, setstatus] = useState("");
  const [isOpenTransfer, setTransfer] = useState(false);
  const { showToast } = useToaster();
  const [tableData, setTableData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);

  const [searchQuery, setSearchQuery] = useState<string>(() => {
    return sessionStorage.getItem("searchQuery") || "";
  });

  const [currentPage, setCurrentPage] = useState<number>(() => {
    const savedPage = sessionStorage.getItem("currentPage");
    return savedPage ? parseInt(savedPage) : 0;
  });
  const [selectedIds, setSelectedIds] = useState([]);
  const [totalElement, setTotalElements] = useState(0);
  const [filters, setFilters] = useState<FilterType>({
    role: [],
    status: [],
    leads: [],
    addedByLeads: [],
    assignedTo: [],
    statusInPosts: [],
    serviceFilterInPosts: [],
    featuredTypeFilter: [],
    postType: [],
    pitchedBy: [],
    country: [],
    types: [],
    companyType: [],
    allPost: [],
    allEvents: [],
    allExpiredEvents: [],
  });
  const [isFilterPopupOpen, setIsFilterPopupOpen] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const { setLoading } = useLoader();
  const navigate = useNavigate();
  const [isRefreshPage, setisRefreshPage] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<number | null>(null);
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  const toggleDropdown = (index: number) => {
    setActiveDropdown((prevIndex) => (prevIndex === index ? null : index));
  };
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const handleClickOutside = (event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setActiveDropdown(null);
    }
  };
  const addPost = () => {
    navigate("/vendorDashboard/activateDashboard/printAds/addBanner");
  };
  const handleStatusClick = (postId: any) => {
    console.log("Post ID:", postId);
    localStorage.setItem("postId", postId);
    setIsStatus(true);
  };
  const showData = (item: PostDto) => {
    // addedByfilters('',item.status,item.assignedToId)
  };

  const [submittedData, setSubmittedData] = useState("");
  const handleChange = (selectedOption: any, data: any) => {
    console.log(data?.id, selectedOption);
    setSubmittedData(selectedOption?.value || "");
    setName("assignedToOhers");
    setAssigedName(selectedOption?.firstName);
    setIsAssignable(true);
    setstatus(data);
    console.log("isAssigned:", isAssigned, isAssignable, "isAssignable");
  };
  const queryParams = new URLSearchParams();
  const companyId = queryParams.get("appUserId");
  const isCompany = queryParams.get("isCompany");
  const vendorId = localStorage.getItem("vendorId");
  const postStatusList = filters.statusInPosts;
  console.log("Company ID:", companyId);
  const fetchVehicles = async () => {
    setLoading(true);
    let body: any;
    body = {
      page: currentPage,
      search: searchQuery,
      vendorId: vendorId ? parseInt(vendorId, 10) : 0,
    };
    // }
    try {
      let url: any;
      const response = await postService(API_ENDPOINTS.getPrintADs, body);
      setTableData(response.data.content);
      setTotalPages(response.data.totalPages);
      setTotalElements(response.data.totalElements);
    } catch (error) {
      showToast("error", "error", "");
      console.error("Error fetching vehicle data:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };
  useEffect(() => {
    fetchVehicles();
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [currentPage, searchQuery]);

  const onPageChange = async (page: any) => {
    setCurrentPage(page);
    sessionStorage.setItem("currentPage", page);
  };

  const onNext = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };

  const onPrevious = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSearchQuery = event.target.value;

    // Update state
    setSearchQuery(newSearchQuery);
    setCurrentPage(0);

    // Persist to sessionStorage
    sessionStorage.setItem("searchQuery", newSearchQuery);
    sessionStorage.setItem("currentPage", "0");
  };

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      sessionStorage.removeItem("currentPage");
      sessionStorage.removeItem("searchQuery");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  const postsCount = async () => {
    try {
      let url: string;
      url = API_ENDPOINTS.postCount;
      // Determine the endpoint based on the user role
      // Make the API request with the determined URL
      const response = await getService(url);
      setPostCount(response.data); // Update the post count with the fetched data
    } catch (error) {
      console.error("Error fetching post count:", error);
    }
  };
  const handleEdit = (data: any) => {
    navigate(
      "/vendorDashboard/activateDashboard/printAd/ViewPrintAd?appUserId=" +
        data?.id
    );
  };

  const [sort, setSort] = useState<SortType>({ column: "", direction: 1 });
  const handleSort = (column: string) => {
    const direction = sort.column === column && sort.direction == 1 ? 0 : 1;
    setSort({ column, direction });
  };
  const view = (data: any) => {
    navigate(
      "/vendorDashboard/activateDashbord/printAd/ViewPrintAd?appUserId=" +
        data?.id
    );
  };

  return (
    <div className="h-full py-2 w-full relative md:px-8">
      <div className="py-4"></div>
      <div className="flex items-center mb-3 mt-2 cursor-pointer justify-between">
        <div className="flex items-center">
          <>
            <h1 className="text-2xl font-bold mb-2 text-[#2D2E2F] mr-3">
              Magazine Advertisements
            </h1>
          </>
        </div>
        {/* <div className='flex items-center '>
          {userInfo?.roles ==='PUBLISHER' &&
        <div className='flex items-center gradient-background p-2 text-white font-bold text-sm px-4' onClick={addPost}><span className='mr-2'>+</span>Add Advertisement</div>
          }
        </div> */}
      </div>

      {/* <div className="overflow-x-auto scroolCls">
    <table className="min-w-full bg-white border border-gray-200 w-full">
   <thead className="bg-gray-100 text-left">
     <tr>
       <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs sticky left-0 bg-gray-100 z-20 w-[50px]">
         #
       </th>
     
       <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs flex items-center">
         <span className="text-gray-600 font-semibold text-xs flex items-center cursor-pointer" onClick={() => handleSort('addedDate')}>Execution Date 
             <img
       className={`ml-2 transform transition-transform duration-300 ${
         sort.column === 'addedDate' && sort.direction === 1 ? 'rotate-180' : ''
       }`}
       src='/images/sortArrow.svg'
     /></span></th>
        <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs w-[250px]">
         Caption
       </th>
   
     </tr>
   </thead>
   <tbody>
     {tableData.map((user: printDto, index: number) => (
       <tr key={index}>
         <td className="px-4 py-3 border-b text-sm text-gray-900 sticky left-0 bg-white font-semibold z-10 cursor-pointer w-[50px] whitespace-nowrap" onClick={()=>view(user)}>
           {user?.uuid || 'NA'}
         </td>
         <td className="px-4 py-3 border-b text-sm text-gray-500 bg-white font-normal cursor-pointer  whitespace-nowrap w-[200px]">
   {user?.addedDate}
 </td>
 
        
         <td className="px-4 py-3 border-b text-sm text-gray-500  font-medium whitespace-nowrap  line-clamp-1">
                     <div className="flex justify-between items-center">
                       <span  className="cursor-pointer">
                        {user?.caption || 'NA'}
                       </span>
                       {(userInfo?.roles === 'PUBLISHER') &&
                              <img
                                src="/images/threeDot.svg"
                                alt="Menu1"
                                className="cursor-pointer ml-5"
                                onClick={() => toggleDropdown(index)}
                              />
}
                             {activeDropdown === index && userInfo?.roles !== 'PUBLISHER'  && (
                                <div ref={dropdownRef} className="absolute right-[22px] mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10 ==">
                                  <div className="py-2">
                                  
                                     <span className='flex px-4 cursor-pointer' onClick={() => handleEdit(user)}>
                                       <img src='/images/editIcon.svg' alt="Edit" />
                                       <a href="#" className="ml-2 block py-2 text-sm text-[#374151] font-normal">
                                         Edit
                                       </a>
                                     </span>
                                 
                                   
                                    
                                  </div>
                                </div>
                              )}
                     </div>
                   </td>
       </tr>
     ))}
   </tbody>
 </table>

  {!tableData.length && <p className="text-center p-2 bg-white">Your data will appear here once added.</p>}

  {totalPages > 1 && (
    <Pagination
      currentPage={currentPage}
      totalPages={totalPages}
      totalElement={totalElement}
      onPageChange={onPageChange}
      onNext={onNext}
      onPrevious={onPrevious}
    />
  )}
</div> */}
      <div className="overflow-x-auto scroolCls">
        <table className="min-w-full bg-white border border-gray-200 w-full">
          <thead className="bg-gray-100 text-left">
            <tr>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs sticky left-0 bg-gray-100 z-20 w-[50px]">
                #
              </th>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs w-[450px]">
                Caption
              </th>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs w-[150px]">
                <span
                  className="text-gray-600 font-semibold text-xs flex items-center cursor-pointer"
                  onClick={() => handleSort("addedDate")}
                >
                  Upload Date
                  <img
                    className={`ml-2 transform transition-transform duration-300 ${
                      sort.column === "addedDate" && sort.direction === 1
                        ? "rotate-180"
                        : ""
                    }`}
                    src="/images/sortArrow.svg"
                  />
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((user: printDto, index: number) => (
              <tr key={index}>
                <td
                  className="px-4 py-3 border-b text-sm text-gray-900 sticky left-0 bg-white font-semibold z-10 cursor-pointer w-[50px] whitespace-nowrap"
                  onClick={() => view(user)}
                >
                  {user?.uuid || "NA"}
                </td>
                <td className="px-4 py-3 border-b text-sm text-gray-800 font-medium line-clamp-1">
                  <div className="flex justify-between items-center">
                    <span className="cursor-pointer line-clamp-1">
                      {user?.caption || "NA"}
                    </span>
                  </div>
                </td>

                <td className="px-4 py-3 border-b text-sm text-gray-500 bg-white font-normal cursor-pointer whitespace-nowrap w-[100px]">
                  <div className="flex justify-between items-center">
                    <span className="cursor-pointer line-clamp-1">
                      {user?.addedDate || "NA"}
                    </span>
                    {/* {
      userInfo?.roles ==='PUBLISHER' &&
    <img
      src="/images/threeDot.svg"
      alt="Menu1"
      className="cursor-pointer ml-5"
      onClick={() => toggleDropdown(index)}
    />}
     {activeDropdown === index   && (
                                <div ref={dropdownRef} className="absolute right-[22px] mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10 ==">
                                  <div className="py-2">

                                     <span className='flex px-4 cursor-pointer' onClick={() => handleEdit(user)}>
                                       <img src='/images/editIcon.svg' alt="Edit" />
                                       <a href="#" className="ml-2 block py-2 text-sm text-[#374151] font-normal">
                                         Edit
                                       </a>
                                     </span>
                                  </div>
                                </div>
                              )} */}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {!tableData.length && (
          <p className="text-center p-2 bg-white">
            Your data will appear here once added.
          </p>
        )}

        {totalPages > 1 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalElement={totalElement}
            onPageChange={onPageChange}
            onNext={onNext}
            onPrevious={onPrevious}
          />
        )}
      </div>
    </div>
  );
};
export default PrintAd;
